// app/Scripts/Components/videos.js
(function() {
	'use strict'
	
	// query und queryAll lokal definieren
	function query(sel, ctx) {
		ctx = ctx || document
		return ctx.querySelector(sel)
	}
	
	function queryAll(sel, ctx) {
		ctx = ctx || document
		return Array.prototype.slice.call(ctx.querySelectorAll(sel))
	}
	
	// Initialisierung
	function initVideos() {
		queryAll('.lazy-video').forEach(function(el) {
			var poster = el.querySelector('.video-poster')
			var button = el.querySelector('.video-button')
			var videoID = el.dataset.youtube
			
			if (poster && videoID) {
				poster.style.background = `url(//img.youtube.com/vi/${videoID}/maxresdefault.jpg) center / cover no-repeat`
			}
			
			if (button && videoID) {
				button.addEventListener('click', function onClick(e) {
					button.removeEventListener('click', onClick)
					button.innerHTML = `<iframe src="//www.youtube.com/embed/${videoID}?autoplay=1" frameborder="0" allowfullscreen></iframe>`
				})
			}
		})
		
		console.log('Videos: Lazy-Video initialisiert')
	}
	
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initVideos)
	} else {
		initVideos()
	}
	
})()